import {
    LOGIN_VALIDATE_USER_START,
    LOGIN_VALIDATE_USER_SUCCESS,
    LOGIN_VALIDATE_USER_FAILURE,
    LOGIN_USER_MODIFIED,
    LOGIN_PASSWORD_MODIFIED,
} from '../actions/LoginActions';

import {
    TABLE_NAME_SELECTED,
} from '../app-constants';

const initialState = {
    userid: '',
    password: '',
    username: '',
    allowEdit: true,
    allowDelete: true,
    allowAdd: true,
    tableName: '',
    view: '',
    loginStatus: 'LOGGED_OUT',
    validatingUser: false,
    adminUser: false,
};

const reducerOutput = (state = initialState, action) => {
    switch (action.type) {

        case LOGIN_VALIDATE_USER_START:
            return {
                ...state,
                validatingUser: true,
                message: '',
                messageType: '',
            };

        case LOGIN_VALIDATE_USER_SUCCESS:
            return {
                ...state,
                validatingUser: false,
                loginStatus: 'LOGGED_IN',
                message: '',
                messageType: '',
            };

        case LOGIN_VALIDATE_USER_FAILURE:
            return {
                ...state,
                validatingUser: false,
                loginStatus: 'LOGGED_OUT',
                message: action.message,
                messageType: 'error',
            };

        case LOGIN_USER_MODIFIED:
            return {
                ...state,
                userid: action.payload.userid,
            };

        case LOGIN_PASSWORD_MODIFIED:
            return {
                ...state,
                password: action.payload.password,
            };

        case TABLE_NAME_SELECTED:
            return {
                ...state,
                tableName: action.tableName,
            };

        default:
            return state;
    }
}

export default reducerOutput;
